import { render } from "./ActivationData.vue?vue&type=template&id=4830c6c5&scoped=true"
import script from "./ActivationData.vue?vue&type=script&lang=js"
export * from "./ActivationData.vue?vue&type=script&lang=js"

import "./ActivationData.vue?vue&type=style&index=0&id=4830c6c5&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4830c6c5"]])

export default __exports__